// newsletter
export const newsletter2x = require("../../assets/img/newsletter_2x.png");
export const newsletter1x = require("../../assets/img/newsletter_1x.png");

// directory
export const sofas2x = require("../../assets/img/sofas_2x.jpg");
export const sofas1x = require("../../assets/img/sofas_1x.jpg");
export const sofasMobile2x = require("../../assets/img/sofas_mobile_2x.jpg");
export const sofasMobile1x = require("../../assets/img/sofas_mobile_1x.jpg");
export const lighting2x = require("../../assets/img/lighting_2x.jpg");
export const lighting1x = require("../../assets/img/lighting_1x.jpg");
export const lightingMobile2x = require("../../assets/img/lighting_mobile_2x.jpg");
export const lightingMobile1x = require("../../assets/img/lighting_mobile_1x.jpg");
export const tables2x = require("../../assets/img/tables_2x.jpg");
export const tables1x = require("../../assets/img/tables_1x.jpg");
export const tablesMobile2x = require("../../assets/img/tables_mobile_2x.jpg");
export const tablesMobile1x = require("../../assets/img/tables_mobile_1x.jpg");
export const bedding2x = require("../../assets/img/bedding_2x.jpg");
export const bedding1x = require("../../assets/img/bedding_1x.jpg");
export const beddingMobile2x = require("../../assets/img/bedding_mobile_2x.jpg");
export const beddingMobile1x = require("../../assets/img/bedding_mobile_1x.jpg");
export const decor2x = require("../../assets/img/decor_2x.jpg");
export const decor1x = require("../../assets/img/decor_1x.jpg");
export const decorMobile2x = require("../../assets/img/decor_mobile_2x.jpg");
export const decorMobile1x = require("../../assets/img/decor_mobile_1x.jpg");
export const chairs2x = require("../../assets/img/chairs_2x.jpg");
export const chairs1x = require("../../assets/img/chairs_1x.jpg");
export const chairsMobile2x = require("../../assets/img/chairs_mobile_2x.jpg");
export const chairsMobile1x = require("../../assets/img/chairs_mobile_1x.jpg");

// video banner
export const lightingVideoPoster = require("../../assets/img/lighting_video/lighting_poster.jpg");

// curated room
export const curatedMobile_400w = require("../../assets/img/home/curated-space/curated_mobile_400w.jpg");
export const curatedMobile_800w = require("../../assets/img/home/curated-space/curated_mobile_800w.jpg");
export const curatedMobile_1400w = require("../../assets/img/home/curated-space/curated_mobile_1400w.jpg");
export const curatedTablet_1000w = require("../../assets/img/home/curated-space/curated_tablet_1000w.jpg");
export const curatedTablet_2000w = require("../../assets/img/home/curated-space/curated_tablet_2000w.jpg");
export const curatedDesktop_1200w = require("../../assets/img/home/curated-space/curated_desktop_1200w.jpg");
export const curatedDesktop_1800w = require("../../assets/img/home/curated-space/curated_desktop_1800w.jpg");
export const curatedDesktop_2400w = require("../../assets/img/home/curated-space/curated_desktop_2400w.jpg");
export const curatedDesktop_3000w = require("../../assets/img/home/curated-space/curated_desktop_3000w.jpg");
